import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import {
    SITE_DETAILS,
    SITE_DETAILS_BY_NO,
    MATERIAL_DATA,
    ASSOCIATE_MATERIAL,
    SAVE_MATERIAL,
    MATERIAL_TYPES,
    GET_REPORTEE,
    GET_WAREHOUSE,
    PENDING_MATERIAL,
    VIEW_MATERIAL,
    MATERIAL_APPROVAL,
    CREDITLIMIT_LEDGER,
    TO_EMPLOYEE,
    STORE_ADDRESS,
    ERP_INVENTORY,
    EMP_MRF_LISTING,
    EMP_MRF_MATERIAL,
    INCREASE_CREDIT_LIMIT, USER_CREDIT_LIMIT,CAT_BY_BRAND,GET_CAT, FETCH_MRF_LIST, MRF_TYPE_DROPDOWN, SHOW_MRF_VIEW, SALES_RETURN_MRF, SALES_RETURN_MRF_SHIPMENT, SEND_SALES_RETURN_TO_ERP, MRF_TYPE_LIST,
    MRF_TYPE_DROPDOWN_DATA, CREATE_MRF_TYPE, EDIT_MRF_TYPE, DELETE_MRF_TYPE
} from "./type";

/**
 *
 * @returns {(function(*): Promise<boolean|undefined>)|*}
 */
export const siteData = (flag = false, mrf_type_id = 0) => async (dispatch) => {
    let url = `${Config.materialRequistionForm.getSiteDetails}`;
    
    if (flag) {
        url += `?flag=${flag}`;
    }

    if (mrf_type_id) {
        if(flag){
            url += `&mrf_type_id=${mrf_type_id}`;
        }
        else{
            url += `?mrf_type_id=${mrf_type_id}`;
        }
    }

    const res = await callWebService(callTypes.get, '', url);

    if (res) {
        const { data } = res;
        const rawPayload = data?.data ?? data?.response?.data ?? [];
        const normalizedSites = Array.isArray(rawPayload)
            ? rawPayload
            : (Array.isArray(rawPayload?.data) ? rawPayload.data : []);
        dispatch({
            type: SITE_DETAILS,
            payload: normalizedSites,
        });
        return true;
    }

    return false;
};

/**
 *
 * @param siteNo
 * @returns {(function(*): Promise<boolean|undefined>)|*}
 */
export const siteDataBySiteNo = (siteNo, siteDataBySiteNo) => async (dispatch) => {
    dispatch({
        type: SITE_DETAILS_BY_NO,
        payload: null,
    });
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.materialRequistionForm.siteDetailsBySiteNo}?site_no=${siteNo}&mrf_id=${siteDataBySiteNo}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: SITE_DETAILS_BY_NO,
            payload: data.response,
        });
        return true;
    }
};


/**
 * @returns {(function(*): Promise<boolean|undefined>)|*}
 */
export const getmaterial = (type , brandId = null,categoryId = null) => async (dispatch) => {
    dispatch({
        type: MATERIAL_DATA,
        payload: [],
    });
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.materialRequistionForm.material}?type=${type}&brandId=${brandId}&categoryId=${categoryId}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: MATERIAL_DATA,
            payload: data.response.data,
        });
        return true;
    }
};

export const getCategoryBrand = (id) => async (dispatch) => {
    dispatch({ type: CAT_BY_BRAND, payload: [] });
    const res = await callWebService(
      callTypes.post,
      "",
      `${Config.postSales.getBrand}${id}`
    );
    if (res?.data?.status === true) {
      const { data } = res;
      dispatch({ type: CAT_BY_BRAND, payload: data.response.data });
      return true;
    }
  };

//   getCategoryData

export const getCategoryData = (type) => async (dispatch) => {
    const res = await callWebService(
      callTypes.get,
      "",
      `${Config.materialRequistionForm.getCategoryData}?type=${type}`
    );
    if (res?.data?.status === true) {
      const { data } = res;
      dispatch({ type: GET_CAT, payload: data.response.data });
      return true;
    }
  };

/**
 *
 * @param material_id
 * @param materialTypeId
 * @returns {(function(*): Promise<boolean|undefined>)|*}
 */
export const associateMaterial = (material_id, materialTypeId) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.materialRequistionForm.associateMaterial}?material_id=${material_id}&material_type_id=${materialTypeId}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: ASSOCIATE_MATERIAL,
            payload: data.response.data,
        });
        return true;
    }
};

/**
 *
 * @param obj
 * @returns {(function(*): Promise<boolean|undefined>)|*}
 */
export const saveMaterial = (obj) => async (dispatch) => {
    // console.log(obj); return false;
    const res = await callWebService(
        callTypes.post,
        obj,
        `${Config.materialRequistionForm.save}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: SAVE_MATERIAL,
            payload: data,
        });
        return true;
    }
};

export const materialTypes = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.materialRequistionForm.materialTypes}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: MATERIAL_TYPES,
            payload: data.response.data,
        });
        return true;
    }
};

export const getReportee = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.materialRequistionForm.reportee}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: GET_REPORTEE,
            payload: data.response.data,
        });
        return true;
    }
};

export const getWarehouse = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.materialRequistionForm.warehouse}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: GET_WAREHOUSE,
            payload: data.response.data,
        });
        return true;
    }
};

export const getPending = (page = 1, listType, filterData=null) => async (dispatch) => {
    dispatch({
        type: PENDING_MATERIAL,
        payload: null,
    });
    const res = await callWebService(
        callTypes.get,
        '',
        filterData === null ? `${Config.materialRequistionForm.pendingMaterial}?page=${page}&list_type=${listType}`: `${Config.materialRequistionForm.pendingMaterial}?site_no=${filterData.site_number}&mrf_no=${filterData.mrf_number}&mrf_created_by=${filterData.created_by}&page=${page}&list_type=${listType}`
        //`${Config.materialRequistionForm.pendingMaterial}?page=${page}&list_type=${listType}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: PENDING_MATERIAL,
            payload: data.response.data,
        });
        return true;
    }
};

export const viewMaterial = (id, listType) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.materialRequistionForm.ViewMaterial}?list_type=${listType}&id=${id}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: VIEW_MATERIAL,
            payload: data.response.data,
        });
        return true;
    }
};

export const MrfApproval = (data) => async (dispatch) => {
    dispatch({
        type: MATERIAL_APPROVAL,
        payload: null,
    });
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.materialRequistionForm.approval}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: MATERIAL_APPROVAL,
            payload: data,
        });
        return true;
    }
};

export const getLedger = (page = 1) => async (dispatch) => {
    dispatch({
        type: CREDITLIMIT_LEDGER,
        payload: null,
    });
    const res = await callWebService(
      callTypes.get,
      '',
      `${Config.materialRequistionForm.creditLimitListing}?page=${page}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: CREDITLIMIT_LEDGER,
            payload: data.response.data,
        });
        return true;
    }
};


export const getToEmployee = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.materialRequistionForm.toEmployee}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: TO_EMPLOYEE,
            payload: data.response.data,
        });
        return true;
    }
};

export const getStoreAddress = (id) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.materialRequistionForm.storeAddress}?id=${id}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: STORE_ADDRESS,
            payload: data.response,
        });
        return true;
    }
};

export const getErpInventory = (mrf_type, from_id, material_id, emailId = '') => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.erp.erpInventory}?mrf_type=${mrf_type}&from_id=${from_id}&material_id=${material_id}&email=${emailId}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: ERP_INVENTORY,
            payload: data.response,
        });
        return data.response;
    }
};

export const getEmpMrfListing = (page = 1) => async (dispatch) => {
    dispatch({
        type: EMP_MRF_LISTING,
        payload: null,
    });
    const res = await callWebService(
      callTypes.get,
      '',
      `${Config.materialRequistionForm.empMrfListing}?page=${page}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: EMP_MRF_LISTING,
            payload: data.response.data,
        });
        return true;
    }
};

export const viewEmpMrfMaterial = (id, listType) => async (dispatch) => {
    const res = await callWebService(
      callTypes.get,
      '',
      `${Config.materialRequistionForm.empMrfMaterial}?list_type=2&id=${id}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: EMP_MRF_MATERIAL,
            payload: data.response.data,
        });
        return true;
    }
};

export const saveEmpMrfSerialNo = (obj) => async (dispatch) => {
    const res = await callWebService(
      callTypes.post,
      obj,
      `${Config.materialRequistionForm.saveEmpMrfSerialNo}`
    );
    if (res?.data?.response?.status === true) {
        return true;
    } else {
        return false;
    }
};

export const increaseCreditLimit = (obj) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        obj,
        `${Config.materialRequistionForm.userCreditLimit}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: INCREASE_CREDIT_LIMIT,
            payload: data,
        });
        return true;
    }
};

export const getUserCreditLimit = (page=1) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.materialRequistionForm.getUserCreditLimit}?page=${page}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: USER_CREDIT_LIMIT,
            payload: data?.response?.data,
        });
        return true;
    }
};


// export const fetchMrfList = (page=1, filterData = null) => async (dispatch) => {
//     const res = await callWebService(
//         callTypes.get,
//         '',
//         `${Config.materialRequistionForm.fetchMrfListing}?page=${page}&mrf_no=${filterData?.mrf_no}&site_number=${filterData?.site_number}&mrf_type=${filterData?.mrf_type}&mrf_status=${filterData?.mrf_status}`
//     );
//     if (res) {
//         const { data } = res;
//         dispatch({
//             type: FETCH_MRF_LIST,
//             payload: data?.response?.data,
//         });
//         return true;
//     }
// };


export const fetchMrfList = (page = 1, filterData = null) => async (dispatch) => {
    dispatch({
        type: FETCH_MRF_LIST,
        payload: null,
    });

    let url = `${Config.materialRequistionForm.fetchMrfListing}?page=${page}`;

    if (filterData !== null) {
        url += `&mrf_no=${filterData.mrf_no}&site_number=${filterData.site_number}&mrf_type=${filterData.mrf_type}&mrf_status=${filterData.mrf_status}`;
    }

    const res = await callWebService(
        callTypes.get,
        '',
        url
    );

    if (res) {
        const { data } = res;
        dispatch({
            type: FETCH_MRF_LIST,
            payload: data.response.data,
        });
        return true;
    }
};


export const mrfViewShown = (mrfId = null) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.materialRequistionForm.showMrfView}?mrf_id=${mrfId}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: SHOW_MRF_VIEW,
            payload: data?.response?.data,
        });
        return true;
    }
};

export const dropDownForMrfType = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.materialRequistionForm.mrfTypeDropdown}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: MRF_TYPE_DROPDOWN,
            payload: data?.response?.data,
        });
        return true;
    }
};

export const fetchSalesReturnMrfShipments = (outWardMrfNumber) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.materialRequistionForm.fetchSalesOrderReturnMrf}?outward_mrf_number=${outWardMrfNumber}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: SALES_RETURN_MRF_SHIPMENT,
            payload: data?.response?.data,
        });
        return true;
    }
};

export const fetchSalesReturnMrfDetails = (outWardMrfNumber,shipmentId) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.materialRequistionForm.fetchSalesOrderReturnMrfDetails}?outward_mrf_number=${outWardMrfNumber}&challan_id=${shipmentId}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: SALES_RETURN_MRF,
            payload: data?.response?.data,
        });
        return true;
    }
};

export const sendSalesReturnDataToErp = (obj) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        obj,
        `${Config.materialRequistionForm.sendSalesReturnToErp}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: SEND_SALES_RETURN_TO_ERP,
            payload: data,
        });
        return true;
    }
};

export const getMrfTypeList = (filterData, page = 1, id = null) => async (dispatch) => {
    dispatch({
        type: MRF_TYPE_LIST,
        payload: [],
    });

    let url = `${Config.materialRequistionForm.getMrfTypeList}?page=${page}`;

    if (filterData !== null) {
        url += `&name=${filterData.name || ''}`;
    }

    if (id !== null) {
        url += `&id=${id}`;
    }

    const res = await callWebService(callTypes.get, '', url);

    if (res.data.status === 0) {     
        dispatch({
        type: MRF_TYPE_LIST,
        payload: res?.data?.data || {},
        });
    } else {
        console.log(res);
        return res;
    }
};

export const getMrfTypeDropdownData = () => async (dispatch) => {
    dispatch({
        type: MRF_TYPE_DROPDOWN_DATA,
        payload: [],
    });

    let url = `${Config.materialRequistionForm.getMrfTypeDropdownData}`;

    const res = await callWebService(callTypes.get, '', url);

    if (res.data.status === 0) {
        dispatch({
        type: MRF_TYPE_DROPDOWN_DATA,
        payload: res.data.data || {},
        });
    } else {
        return res;
    }
};

export const createMrfType = (data) => async (dispatch) => {

    try{  
        const res = await callWebService(
            callTypes.post,
            data,
            `${Config.materialRequistionForm.createMrfType}`
        );
        if (res.data.status == 0) {
            const { data } = res;
            dispatch({
                type: CREATE_MRF_TYPE,
                payload: data,
            });
            return data;
        }
    }
    catch(error){
        return error;
    }

};

export const editMrfType = (data) => async (dispatch) => {

    try{
        const res = await callWebService(callTypes.post,data,`${Config.materialRequistionForm.editMrfType}`);
        if (res.data.status == 0) {
            const { data } = res;
            dispatch({
                type: EDIT_MRF_TYPE,
                payload: data,
            });
            return data;
        }
    }
    catch(error){
        return error;
    }

};
